import React, { useState, forwardRef, useImperativeHandle, useEffect, useRef } from "react";
import urlParser from "js-video-url-parser/dist/jsVideoUrlParser.js?v=1.2";
import ImageBrowse from "../../../../Common/Image/ImageBrowse";
import { _showToast } from "../../../../../toastHelper";
import StepperNavigationButtons from "../../../MyInvitations/Common/StepperNavigationButtons";

const ContactUs = forwardRef(function ContactUs(props, ref) {
  const [expiration, setExpiration] = useState(7);
  const [heading, setHeading] = useState("");
  const [paragraph, setParagraph] = useState("");
  const [subHeading, setSubHeading] = useState("");
  const [eventName, setEventName] = useState("");
  const [email, setEmail] = useState("");
  const [address, setAddress] = useState("");
  const [liveUrl, setLiveUrl] = useState("");
  const [facebook, setFacebook] = useState("");
  const [twitter, setTwitter] = useState("");
  const [youtube, setYoutube] = useState("");
  const [instagram, setInstagram] = useState("");
  const [linkedin, setLinkedin] = useState("");
  const [errors, setErrors] = useState({});
  const thumbnailRef = useRef();
const [imageKey, setImageKey] = useState(null);
    const imageRef = useRef();
    const [file3, setFile3] = useState(null);
  useEffect(() => {
    resetData();
    if (props.data) {
      setEmail(props.data.heading);
      setSubHeading(props.data.subHeading);
      setEventName(props.data.title);
      setAddress(props.data.address);
      setFacebook(props.data.facebook);
      setTwitter(props.data.twitter);
      setYoutube(props.data.youtube);
      setInstagram(props.data.instagram);
      setLinkedin(props.data.linkedin);
      setParagraph(props.data.paragraph);

      setExpiration(props.data.expiration);
      setLiveUrl(props.data.liveUrl);
      setImageKey(props.data.imageKey);
      imageRef?.current?.setThumbnail(props.data.image && props.data.image != "" ? props.data.image : null);
      imageRef?.current?.setFileContent(props.data.imageFile);
    }
  }, [props.data]);

  const resetData = () => {
    setHeading("");
    setSubHeading("");
    setEmail("");
    setEventName("");
    setAddress("");
    setFacebook("");
    setTwitter("");
    setYoutube("");
    setInstagram("");
    setLinkedin("");
    setParagraph("");
    setExpiration(7);
    setLiveUrl("");

  }

  const validate = () => {
    const errors = {};

    setErrors(errors);
    return Object.keys(errors).length === 0;
  }

  const getData = () => {
    let url =` <iframe 
    src="${liveUrl}" 
    width="600" height="450" style="border-radius:20px;" allowfullscreen="" loading="lazy"
    referrerpolicy="no-referrer-when-downgrade">
</iframe>`
    const data = {
      Heading:heading,
      subHeading:subHeading,
      title: eventName,
      email: email,
      address:address,
      facebook:facebook,
      twitter:twitter,
      youtube: youtube,
      instagram:instagram,
      linkedin:linkedin,
      paragraph:paragraph,
      expiration: expiration ?? 7,
      liveUrl: url,
      image: imageRef?.current?.getThumbnail() ?? null,
      imageFile: imageRef?.current?.getImageFile() ?? null,
      imageKey: imageKey,
    };
    console.log("data",data)
    if (props.onDataReceive) {
      props.onDataReceive(data);
    }
    return data;
  }
  const handleCroppedImage3 = (file) => {
    setFile3(file) 
 }
  useImperativeHandle(ref, () => ({
    getData: getData,
    validate: validate
  }));
  return (
    <>
      <div className="content" style={{ display: "block", visibility: "visible" }}>
        <div className="content-header mb-3">
          <div className="sec-titler">
            <h2 className="text-primary">Contact Us Page</h2>
            <div className="title-shape"></div>
          </div>
        </div>
        <form>
          <div className="row mt-4">
            <div className="col-sm-6">
              <label className="form-label required" htmlFor="invitationTitle">
              Heading
              </label>
              <input
                type="text"
                id="invitationTitle"
                name="invitationTitle"
                className={`form-control ${errors.heading ? "is-invalid" : ""}`}
                placeholder="Enter your Phone Number here"
                value={heading}
                onChange={(e) => setHeading(e.target.value)}
              />
              {errors.Heading && (
                <div className="invalid-feedback">
                  {errors.Heading}
                </div>
              )}
            </div>
            <div className="col-sm-6">
              <label className="form-label required" htmlFor="invitationTitle">
              Sub Heading
              </label>
              <input
                type="text"
                id="invitationTitle"
                name="invitationTitle"
                className={`form-control ${errors.subHeading ? "is-invalid" : ""}`}
                placeholder="Enter your Phone Number here"
                value={subHeading}
                onChange={(e) => setSubHeading(e.target.value)}
              />
              {errors.subHeading && (
                <div className="invalid-feedback">
                  {errors.subHeading}
                </div>
              )}
            </div>
           
            <div className="col-sm-6">
              <label className="form-label required" htmlFor="invitationTitle">
              Phone Number
              </label>
              <input
                type="number"
                id="invitationTitle"
                name="invitationTitle"
                className={`form-control ${errors.eventName ? "is-invalid" : ""}`}
                placeholder="Enter your Phone Number here"
                value={eventName}
                onChange={(e) => setEventName(e.target.value)}
              />
              {errors.eventName && (
                <div className="invalid-feedback">
                  {errors.eventName}
                </div>
              )}
            </div>
            <div className="col-sm-6">
              <label className="form-label required" htmlFor="dateofevent">
                Email Id
              </label>
              <input type="email"
                id="dateofevent"
                name="dateofevent"
                className={`form-control ${errors.email ? "is-invalid" : ""}`}
                data-date-format="dd-mm-yyyy"
                placeholder="Please enter your email id"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              {errors.email && (
                <div className="invalid-feedback">
                  {errors.email}
                </div>
              )}
            </div>

            <div className="col-sm-6 mt-3">
              <label className="form-label required" htmlFor="dateofevent">
               Address Line
              </label>
              <textarea 
              type="text"
                id="dateofevent"
                name="dateofevent"
                className={`form-control ${errors.address ? "is-invalid" : ""}`}
                data-date-format="dd-mm-yyyy"
                placeholder="Please enter Address Here"
                value={address}
                onChange={(e) => setAddress(e.target.value)}
              />
            </div>
            <div className="col-sm-6 mt-3" >
              <label className="form-label" htmlFor="liveurl">
                Location Url
              </label>
              <textarea 
              type="text"
                id="liveurl"
                name="liveurl"
                className={`form-control ${errors.liveUrl ? "is-invalid" : ""}`}
                placeholder="Enter Location Url Here"
                value={liveUrl}
                onChange={(e) => setLiveUrl(e.target.value)}
              />
              {errors.liveUrl && (
                <div className="invalid-feedback">
                  {errors.liveUrl}
                </div>
              )}
            </div>

            <div className="col-sm-6 mt-3">
              <label className="form-label" htmlFor="dateofevent">
             Face Book
              </label>
              <input type="text"
                id="dateofevent"
                name="dateofevent"
                className={`form-control ${errors.facebook ? "is-invalid" : ""}`}
                data-date-format="dd-mm-yyyy"
                placeholder="Please enter Face Book profile"
                value={facebook}
                onChange={(e) => setFacebook(e.target.value)}
              />
            </div>
            <div className="col-sm-6 mt-3">
              <label className="form-label" htmlFor="dateofevent">
             Twitter
              </label>
              <input type="text"
                id="dateofevent"
                name="dateofevent"
                className={`form-control ${errors.twitter ? "is-invalid" : ""}`}
                data-date-format="dd-mm-yyyy"
                placeholder="Please enter Twitter profile"
                value={twitter}
                onChange={(e) => setTwitter(e.target.value)}
              />
            </div>
            <div className="col-sm-6 mt-3">
              <label className="form-label" htmlFor="dateofevent">
             Youtube
              </label>
              <input type="text"
                id="dateofevent"
                name="dateofevent"
                className={`form-control ${errors.youtube ? "is-invalid" : ""}`}
                data-date-format="dd-mm-yyyy"
                placeholder="Please enter Youtube Link here"
                value={youtube}
                onChange={(e) => setYoutube(e.target.value)}
              />
            </div>
            <div className="col-sm-6 mt-3">
              <label className="form-label" htmlFor="dateofevent">
             Instagram
              </label>
              <input type="text"
                id="dateofevent"
                name="dateofevent"
                className={`form-control ${errors.instagram ? "is-invalid" : ""}`}
                data-date-format="dd-mm-yyyy"
                placeholder="Please enter Instagram Link here"
                value={instagram}
                onChange={(e) => setInstagram(e.target.value)}
              />
            </div>
            <div className="col-sm-6 mt-3">
              <label className="form-label" htmlFor="dateofevent">
              Linkedin
              </label>
              <input type="text"
                id="dateofevent"
                name="dateofevent"
                className={`form-control ${errors.linkedin ? "is-invalid" : ""}`}
                data-date-format="dd-mm-yyyy"
                placeholder="Please enter Instagram Link here"
                value={linkedin}
                onChange={(e) => setLinkedin(e.target.value)}
              />
            </div>
            <div className="col-sm-6">
              <label className="form-label required" htmlFor="invitationTitle">
              paragraph
              </label>
              <textarea
                type="text"
                id="invitationTitle"
                name="invitationTitle"
                className={`form-control ${errors.paragraph ? "is-invalid" : ""}`}
                placeholder="Enter your Phone Number here"
                value={paragraph}
                onChange={(e) => setParagraph(e.target.value)}
              />
              {errors.paragraph && (
                <div className="invalid-feedback">
                  {errors.paragraph}
                </div>
              )}
            </div>
            <div className="col-sm-6">
            <div className="row ">
              <div >
                <label className="form-label" htmlFor="image">
                   Image <small className="text-gray">(Max Allowable File Size: 1MB,Image Dimensions: 750px x 750px)</small>
                </label>
                <ImageBrowse
                elementId="slide3Image" 
                   ref={imageRef} imageType="background"
                  imageKey={imageKey} 
                  setImageKey={setImageKey} 
                  onImageCropped={handleCroppedImage3}
                  imageDelete={props.imageDelete} />
              </div>
            </div>
            
            </div>
          </div>
        
          <StepperNavigationButtons index={props.index} steps={props.steps} navigate={props.navigate} />
        </form>
      </div>
    </>
  );
});

export default ContactUs;